import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["icon", "details"]

  toggle() {
    const open = this.detailsTarget.style.display !== "none"
    this.detailsTarget.style.display = open ? "none" : ""
    this.iconTarget.classList.toggle("ti-chevron-right", open)
    this.iconTarget.classList.toggle("ti-chevron-down", !open)
  }

  stop(event) {
    event.stopPropagation()
  }
}
